<template>
  <label class="form-label" v-if="label" :class="{regist: isRegist}">
    <span class="form-label__label">{{ label }}</span>
    <span v-if="isRequired" class="form-label__badge form-label__badge--required">必須</span>
  </label>
</template>

<script>
export default {
  name: 'form-label',
  data() {
    return {
      isRegist: false
    }
  },
  mounted() {
    this.isRegist = this.register
  },
  props: {
    label: String,
    validation: {
      type: Object,
      default() {
        return { rules: {} }
      }
    },
    required: Boolean,
    register: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRequired() {
      return this.validation.required || this.required
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.form-label {
  font-weight: bold;
  display: flex;
  line-height: 1.1;
  align-items: center;
  margin-bottom: 8px;
  &__label {
    color: $col_base_black;
    font-size: 13px;
  }
  &__badge {
    display: inline-block;
    padding: 2px 5px 2.5px;
    margin: 0 0 2px 5px;
    color: $col_white;
    font-size: 10px;
    line-height: 1;
    text-align: center;
    background: $col_temp_key1;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormLabel.vue